import { _FAILURE, _REQUEST, _SUCCESS, _INIT } from "../constants";

export function getRequestActionType<T extends string>(type: T) {
  return `${type}${_REQUEST}` as const;
}

export function getFailureActionType<T extends string>(type: T) {
  return `${type}${_FAILURE}` as const;
}

export function getSuccessActionType<T extends string>(type: T) {
  return `${type}${_SUCCESS}` as const;
}

export function getInitActionType<T extends string>(type: T) {
  return `${type}${_INIT}` as const;
}
